import axios from "axios";
import { GetUserAccessToken, UserToken } from "../utils/helper";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a request interceptor to include the access token in headers
instance.interceptors.request.use(async (config) => {
  await UserToken();
  const accessToken = GetUserAccessToken();
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

export default instance;
